import React, { memo, useEffect } from 'react';
import { connect } from 'react-redux';

import Popup from 'src/components/helpers/Popup';
import { useSharedPusher, CHANNEL_SCREEN_POP, CHANNEL_SCREEN_POP_ENDED } from 'src/hooks/useSharedPusher';
import outgoingCallGif from 'src/assets/img/general/outgoingCall.gif';
import { usePopupContext } from '../../../contexts/PopupContext';

import style from './style.module.css';

const OutgoingCallPopupComponent = ({ screenPopChannel, user }) => {
  const { closePopup } = usePopupContext();
  const { subscribe } = useSharedPusher(user);

  useEffect(() => {
    if (!screenPopChannel) {
      return;
    }

    const channel = screenPopChannel.get('name');

    subscribe(channel, CHANNEL_SCREEN_POP_ENDED, () => {
      closePopup();
    });
  }, [screenPopChannel]);

  return (
    <Popup header="Outgoing Call" id="outgoingCallPopup">
      <div className={style.content}>
        <img alt="Outgoing Call" src={outgoingCallGif} />
      </div>
    </Popup>
  );
};

const mapStateToProps = state => ({
  user: state.auth.get('user', null),
  screenPopChannel: state.dialPadPusher.get('data', null)?.find(channel => channel.get('type') === CHANNEL_SCREEN_POP),
});

/** Outgoing call popup component. */
export const OutgoingCallPopup = connect(mapStateToProps)(memo(OutgoingCallPopupComponent));
